export default __webpack_public_path__ + "../img/3bdcb73812f4ff3aa68de7f0c8263b21.jpg";